import React from "react";

const ManagePlanIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9945 2.98633C9.60541 2.98988 7.31523 3.9415 5.62591 5.63261C3.93659 7.32371 2.98597 9.61632 2.98243 12.0079C2.98104 13.6305 3.41616 15.2234 4.24207 16.6195C5.06799 18.0156 6.25423 19.1633 7.6762 19.942C8.33497 20.2967 9.03556 20.5673 9.76157 20.7475C11.9677 21.2945 14.2979 21.0077 16.306 19.942C17.7271 19.1622 18.9125 18.0143 19.7383 16.6184C20.564 15.2226 20.9998 13.6302 20.9998 12.0079C20.9963 9.61748 20.0466 7.32588 18.3587 5.63497C16.6708 3.94406 14.3824 2.99165 11.9945 2.98633Z"
        stroke="white"
        stroke-width="1.18979"
        className="custom-icon-stroke"
      />
      <path
        d="M14.9655 12.703L15.2699 14.4794C15.2754 14.5445 15.2754 14.6099 15.2699 14.6749C15.2685 14.8544 15.2252 15.031 15.1435 15.1908C15.0617 15.3505 14.9437 15.4888 14.7989 15.5947C14.6035 15.7364 14.3684 15.8129 14.127 15.8132C13.9426 15.8145 13.7608 15.769 13.5987 15.681L12.0021 14.8416L10.3712 15.6982C10.2072 15.787 10.0234 15.8325 9.83707 15.8304C9.61545 15.8186 9.40202 15.7427 9.22257 15.612C9.05135 15.4862 8.9183 15.3154 8.83821 15.1185C8.75812 14.9217 8.73412 14.7064 8.76888 14.4967L9.07326 12.7202L7.7811 11.4612C7.67326 11.3554 7.58731 11.2293 7.52819 11.0903C7.46906 10.9512 7.43791 10.8018 7.43653 10.6506C7.43619 10.5276 7.45558 10.4053 7.49396 10.2884C7.56054 10.0867 7.68165 9.9074 7.84385 9.7704C8.00605 9.6334 8.20299 9.54407 8.41282 9.51231L10.1989 9.2536L10.9971 7.63239C11.0926 7.44277 11.2386 7.28331 11.419 7.17169C11.5995 7.06007 11.8073 7.00064 12.0194 7C12.2315 7.00064 12.4393 7.06007 12.6197 7.17169C12.8001 7.28331 12.9462 7.44277 13.0416 7.63239L13.8169 9.22486L15.5972 9.48356C15.8081 9.51433 16.0062 9.60322 16.1695 9.74028C16.3328 9.87735 16.4548 10.0572 16.5218 10.2597C16.5828 10.4594 16.5882 10.6719 16.5376 10.8745C16.487 11.077 16.3823 11.262 16.2347 11.4095L14.9655 12.703Z"
        stroke="white"
        stroke-width="1.01901"
        className="custom-icon-stroke"
      />
    </svg>
  );
};

export default ManagePlanIcon;
